// 24 hand-rolled glyphs for the "tavern-1" icon set.
// All drawn on a 24x24 viewBox.
export const ICON_PATHS: readonly string[] = [
  // 0 ghost
  'M12 2c-3.3 0-6 2.7-6 6v11.5c0 .9 1 1.4 1.7.9L9 19l1.5 1.4c.4.3 1 .3 1.4 0L13 19l1.3 1.4c.4.3 1 .3 1.4 0L17 19l1.3 1.4c.7.5 1.7 0 1.7-.9V8c0-3.3-2.7-6-6-6h-2zM10 9a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z',
  // 1 cat
  'M3 4l4 3c1.5-.6 3.2-1 5-1s3.5.4 5 1l4-3v8c0 5.5-4.5 10-9 10S3 17.5 3 12V4zm6 7a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2zm-3 5c-1.5 0-2-1-2-1h4s-.5 1-2 1z',
  // 2 owl
  'M12 3a8 8 0 00-8 8v3c0 4 4 7 8 7s8-3 8-7v-3a8 8 0 00-8-8zm-4 7a3 3 0 110 6 3 3 0 010-6zm8 0a3 3 0 110 6 3 3 0 010-6zm-4 7l-1 2h2l-1-2z',
  // 3 mushroom
  'M4 11a8 8 0 0116 0c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2zm5 4h6v4a3 3 0 01-6 0v-4z',
  // 4 candle
  'M12 2c-1.5 2-3 3-3 5a3 3 0 006 0c0-2-1.5-3-3-5zm-3 9h6v9a2 2 0 01-2 2h-2a2 2 0 01-2-2v-9zM7 21h10v2H7v-2z',
  // 5 key
  'M14 2a6 6 0 100 12c.7 0 1.4-.1 2-.3L18 16l3-3-2-2 2-2-3-3-2 2c-.6-.6-2-2-2-6zm0 4a2 2 0 110 4 2 2 0 010-4z',
  // 6 moon
  'M20 13.5A8.5 8.5 0 1110.5 4 7 7 0 0020 13.5z',
  // 7 sun
  'M12 7a5 5 0 110 10 5 5 0 010-10zm0-5v3m0 14v3M2 12h3m14 0h3M5 5l2 2m10 10l2 2M5 19l2-2m10-10l2-2',
  // 8 leaf
  'M3 21S5 12 11 8c5-3 9-3 10-3-1 9-4 13-9 15-2 .8-4 1-9 1zm0 0l8-8',
  // 9 eye
  'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zm10 4a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z',
  // 10 star
  'M12 2l3 7 7 .5-5.5 4.5L18 21l-6-3.5L6 21l1.5-7L2 9.5 9 9z',
  // 11 flame
  'M12 2c0 4-5 5-5 11a5 5 0 0010 0c0-3-2-4-2-7 0-1-1-2-3-4zm-1 12a2 2 0 104 0c0-2-2-2-2-4-1 1-2 2-2 4z',
  // 12 crown
  'M3 6l4 5 5-7 5 7 4-5v12H3V6zm0 14h18v2H3v-2z',
  // 13 skull
  'M12 2a8 8 0 00-8 8v6l3 2v3h3v-2h4v2h3v-3l3-2v-6a8 8 0 00-8-8zm-3 8a2 2 0 110 4 2 2 0 010-4zm6 0a2 2 0 110 4 2 2 0 010-4zm-4 6h2l-1 2-1-2z',
  // 14 fish
  'M2 12c4-6 10-6 14 0-4 6-10 6-14 0zm14 0l5-3v6l-5-3zm-9 0a1 1 0 110 2 1 1 0 010-2z',
  // 15 die
  'M5 5h14v14H5V5zm3 3a1 1 0 100 2 1 1 0 000-2zm8 0a1 1 0 100 2 1 1 0 000-2zm-4 4a1 1 0 100 2 1 1 0 000-2zm-4 4a1 1 0 100 2 1 1 0 000-2zm8 0a1 1 0 100 2 1 1 0 000-2z',
  // 16 anchor
  'M12 2a3 3 0 100 6 3 3 0 000-6zm-1 6h2v3h3v2h-3v8a8 8 0 008-8h-2a6 6 0 01-6 6v-6h-2v6a6 6 0 01-6-6H3a8 8 0 008 8v-8H8v-2h3V8z',
  // 17 mask
  'M3 7c4-2 14-2 18 0-1 7-3 12-9 12S4 14 3 7zm5 4a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4z',
  // 18 hat
  'M12 2l5 8H7l5-8zm-9 9h18l-1 4h2v3H2v-3h2L3 11z',
  // 19 lantern
  'M9 2h6v3h-6V2zm-2 4h10l-1 3v8a3 3 0 01-3 3h-2a3 3 0 01-3-3V9L7 6zm5 14v3',
  // 20 fox
  'M3 6l4 4c1.5-.5 3-.7 5-.7s3.5.2 5 .7l4-4-1 7-3 1c-.5 4-2.5 7-5 7s-4.5-3-5-7l-3-1-1-7zm6 6a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2z',
  // 21 wave
  'M2 16c2-3 4-3 6 0s4 3 6 0 4-3 6 0v3H2v-3zm0-7c2-3 4-3 6 0s4 3 6 0 4-3 6 0',
  // 22 lock
  'M12 2a5 5 0 00-5 5v3H6a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2h-1V7a5 5 0 00-5-5zm-3 8V7a3 3 0 016 0v3H9zm3 4a2 2 0 110 4 2 2 0 010-4z',
  // 23 spider
  'M12 8a4 4 0 100 8 4 4 0 000-8zM2 6l4 4M2 14l4-2M2 18l4-1m18-11l-4 4m4 4l-4-2m4 6l-4-1m-8 4v-3m0-7V4',
];
